import React from "react";

export function PageTitle({ children }) {
  return (
    <div
      style={{
        borderLeft: "4px solid #dc2626",
        paddingLeft: "14px",
        margin: "28px 0 20px",
      }}
    >
      <h1
        style={{
          fontSize: "1.5rem",
          fontWeight: 800,
          color: "#111827",
          margin: 0,
          letterSpacing: "-0.02em",
          lineHeight: 1.2,
        }}
      >
        {children}
      </h1>
    </div>
  );
}

export function SearchInput({ value, onChange, placeholder = "Buscar...", style }) {
  return (
    <div style={{ position: "relative", display: "flex", alignItems: "center", ...style }}>
      <span
        style={{
          position: "absolute",
          left: "10px",
          color: "#9ca3af",
          pointerEvents: "none",
          display: "flex",
          alignItems: "center",
        }}
      >
        <i className="fa-solid fa-magnifying-glass" style={{ fontSize: "12px" }}></i>
      </span>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          width: "100%",
          paddingLeft: "32px",
          paddingRight: "12px",
          paddingTop: "8px",
          paddingBottom: "8px",
          border: "1px solid #d1d5db",
          borderRadius: "7px",
          fontSize: "0.82rem",
          backgroundColor: "#fff",
          outline: "none",
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          transition: "border-color 0.15s, box-shadow 0.15s",
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#dc2626";
          e.target.style.boxShadow = "0 0 0 3px rgba(220,38,38,0.1)";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#d1d5db";
          e.target.style.boxShadow = "0 1px 2px rgba(0,0,0,0.04)";
        }}
      />
    </div>
  );
}
